import reducer from './reducers';

import * as PostingsSelectors from './selectors';
import * as PostingsOperations from './operations';
import * as PostingsTypes from './types';

export { PostingsSelectors, PostingsOperations, PostingsTypes };

export default reducer;
